import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksLinks(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,
		dtConfig[ModulesMap.DONE_WORKS_LINKS].getDoneWorksLinks,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksLinkPreview(companyId, doneWorkId, linkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,
		dtConfig[ModulesMap.DONE_WORKS_LINKS].getDoneWorksLinkPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				linkId,
			},
		},
	)
}
function getDoneWorksLinkPopup(companyId, doneWorkId, linkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,
		dtConfig[ModulesMap.DONE_WORKS_LINKS].getDoneWorksLinkPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				linkId,
			},
		},
	)
}

function createDoneWorksLink(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,dtConfig[ModulesMap.DONE_WORKS_LINKS].createDoneWorksLink, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksLink(companyId, doneWorkId, linkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,dtConfig[ModulesMap.DONE_WORKS_LINKS].getDoneWorksLink, {
		urlParams: {
			companyId,
			doneWorkId,
			linkId,
		},
	})
}

function patchDoneWorksLink(companyId, doneWorkId, linkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,dtConfig[ModulesMap.DONE_WORKS_LINKS].patchDoneWorksLink, {
		urlParams: {
			companyId,
			doneWorkId,
			linkId,
		},
		...data,
	})
}

function putDoneWorksLink(companyId, doneWorkId, linkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,dtConfig[ModulesMap.DONE_WORKS_LINKS].putDoneWorksLink, {
		urlParams: {
			companyId,
			doneWorkId,
			linkId,
		},
		...data,
	})
}

function deleteDoneWorksLink(companyId, doneWorkId, linkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_LINKS,dtConfig[ModulesMap.DONE_WORKS_LINKS].deleteDoneWorksLink, {
		urlParams: {
			companyId,
			doneWorkId,
			linkId,
		},
	})
}

export default {
	getDoneWorksLinks,
	getDoneWorksLinkPopup,
	getDoneWorksLinkPreview,
	getDoneWorksLink,
	patchDoneWorksLink,
	putDoneWorksLink,
	createDoneWorksLink,
	deleteDoneWorksLink,
}
